<template>
  <p class="mb-16 text-static-default-low body-2 whitespace-pre-line">
    {{ i18n(translations.premiumGradeNotice) }}
  </p>
</template>

<script lang="ts" setup>
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'

import translations from './ReviewsPremiumGradeNotice.translations'

const i18n = useI18n()
</script>
